import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-edit-qtb-cancel-dialog",
    templateUrl: "./edit-qtb-cancel-dialog.component.html",
    styleUrls: ["./edit-qtb-cancel-dialog.component.scss"],
    standalone: false,
})
export class EditQtbCancelDialogComponent implements OnInit {
    constructor(private dialogRef: MatDialogRef<EditQtbCancelDialogComponent>) {}

    ngOnInit(): void {}

    onCancel() {
        this.dialogRef.close(false);
    }

    onConfirm() {
        this.dialogRef.close(true);
    }
}
